import {
	type CoachVerificationStatus,
	coachVerificationDecisionSchema,
	coachVerificationListResponseSchema,
} from "../schemas/coach/verification";
import { fetchApi } from "./internal";

/** Bounded review pages; the server permits at most 100 rows. */
export const COACH_VERIFICATION_QUEUE_PAGE_SIZE = 25;
export const DEFAULT_COACH_VERIFICATION_STATUS: CoachVerificationStatus = "pending";

export interface CoachVerificationListParams {
	status?: CoachVerificationStatus;
	limit?: number;
	offset?: number;
}

/** The first pending review page. */
export function coachVerificationQueueParams(): CoachVerificationListParams {
	return {
		limit: COACH_VERIFICATION_QUEUE_PAGE_SIZE,
		offset: 0,
		status: DEFAULT_COACH_VERIFICATION_STATUS,
	};
}

export const coach = {
	verifications: {
		approve: (userId: string) =>
			fetchApi(`/coaches/${userId}/verification`, coachVerificationDecisionSchema, {
				body: JSON.stringify({ status: "verified" }),
				method: "PUT",
			}),
		list: (params?: CoachVerificationListParams) => {
			const search = new URLSearchParams();
			if (params?.status) {
				search.set("status", params.status);
			}
			if (params?.limit !== undefined) {
				search.set("limit", String(params.limit));
			}
			if (params?.offset !== undefined) {
				search.set("offset", String(params.offset));
			}
			const query = search.toString();
			return fetchApi(
				`/coaches/verifications${query ? `?${query}` : ""}`,
				coachVerificationListResponseSchema,
			);
		},
		reject: (userId: string, note?: string) =>
			fetchApi(`/coaches/${userId}/verification`, coachVerificationDecisionSchema, {
				body: JSON.stringify({ note, status: "rejected" }),
				method: "PUT",
			}),
	},
};
